/*
  LP 群 (実プロダクト開発演習、相談、体験、ストーリー、30日チャレンジ、書類) を、HP と同じ女性向けのトーンにする値 (2026-10-19 代表「LP も調整しないとだな」)。
  値は HP の着せ替え (pages/index/sec-women-tone.ts の WOMEN_TONE_VARS) をそのまま読む。拾った場所は notes-sandbox/ops/scratch/2026-10-19/hp-women-tone/tokens.md。

  LP は版を 2 つ持つ。v2 (既定) は根の要素に印のクラス (LP_TONE_CLASS) を付け、そのクラスの下だけに効く CSS を足す。
  v1 は印を付けないので、前の規則がそのまま効く。v1 は各 LP の住所に /v1 を付けた所で出す (noindex、canonical は元の住所、計測に page_variant=v1)
*/

import { useEffect } from "react";
import { WOMEN_TONE_VARS } from "../index/sec-women-tone";

export type LpTone = "v1" | "v2";

/** v2 の印。この下だけに女性向けのトーンの CSS が効く */
export const LP_TONE_CLASS = "lp-w";

/** 下層のページ (料金、受講生の声、よくある質問、比較、コラム、お知らせ、会社概要、問い合わせ、書類) の v2 の印。この下だけに pages/sub-tone.ts の CSS が効く。v1 は持たない */
export const SUB_TONE_CLASS = "sub-w";

/** --w-* の値の束。HP (pages/index/sec-women-tone.ts) の値をそのまま読み、LP で使う 2 つを足す */
export const WOMEN_VARS = `${WOMEN_TONE_VARS}
  --w-line:#06C755;
  --w-navy-grad:radial-gradient(70% 60% at 100% 0,rgba(208,124,124,.28) 0,transparent 70%),linear-gradient(160deg,#315F78 0,#284F64 100%);
`;

/**
 * グラデの見せ場の中で、桜色の字と灰の字をグラデの上でも 4.5 以上に保つ組。見せ場の節に重ねて使う。
 * 値は HP の --w-rose-deep、--w-sub-deep、--w-note-deep (pages/index/sec-women-tone.ts)。ページごとの別名 (--sub、--st-sub など) は各ページの CSS で足す
 */
export const ON_SHOW = "--w-rose-ink:var(--w-rose-deep);--w-cta-ink:var(--w-rose-deep);--w-sub:var(--w-sub-deep);--w-note:var(--w-note-deep);";

/** 住所が /v1 で終わるか。v1 の写しは元の住所に /v1 を付けた所で出す */
export function toneFromPath(pathname: string): LpTone {
  return /\/v1\/?$/.test(pathname) ? "v1" : "v2";
}

/**
 * v1 の写しのとき html に data-page-variant="v1" を付ける。計測 (lib/loadAnalytics.ts) が読んで page_variant を足す。
 * ページの effect は root の effect (loadAnalytics を呼ぶ) より先に走るので、計測の読み込みに間に合う。書き出しの LP は HTML に最初から付いている
 */
export function usePageVariant(tone: LpTone) {
  useEffect(() => {
    if (tone === "v1") document.documentElement.dataset.pageVariant = "v1";
  }, [tone]);
}
